import { useImageViewerStore } from "@mirage/store/store";
import { ImageViewerOptions } from "@mirage/store/imageViewerStore";

export interface ImageViewResult {
    description?: string;
}

export interface ImageViewer {
    show: (base64: string | null, options?: ImageViewerOptions) => Promise<ImageViewResult>;
}

export const useImageViewer = (): ImageViewer => {
    const setImageViewer = useImageViewerStore((s) => s.setImageViewer);
    const resetImageViewer = useImageViewerStore((s) => s.resetImageViewer);

    const show = async (base64: string | null, options?: ImageViewerOptions): Promise<ImageViewResult> => {
        return new Promise<ImageViewResult>((resolve) => {
            const onClose = (description?: string) => {
                resetImageViewer();
                resolve({ description });
            };
            setImageViewer({ base64, options, onClose });
        });
    };

    return { show };
};
